import {
  FULFILLMENT_STATUSES,
  ORDER_METHODS,
  PaymentMethods,
  REFUND_REASONS,
  ROOM_SERVICE_LOCATION_TYPES,
} from '../../../../../services/exports/Constants';
import { OFFER_KIND } from '../../../../../views/menu/offers/constants';

export default {
  title: 'Dettagli ordine',
  sections: {
    driver_info: 'Info corriere',
    order_info: 'Info ordine',
    price_info: 'Info prezzi',
    adjustments: 'Rettifiche',
  },
  order_methods: {
    [ORDER_METHODS.pickup]: 'Asporto',
    [ORDER_METHODS.delivery]: 'Consegna',
    [ROOM_SERVICE_LOCATION_TYPES.room_service]: 'Room service',
    [ROOM_SERVICE_LOCATION_TYPES.table_service]: 'Servizio al tavolo',
  },
  room_service_location_types: {
    [ROOM_SERVICE_LOCATION_TYPES.room_service]: {
      details_label: 'Zimmernummer',
    },
    [ROOM_SERVICE_LOCATION_TYPES.table_service]: {
      details_label: 'Tischnummer',
    },
  },
  fulfillment_statuses: {
    [FULFILLMENT_STATUSES.created]: 'Questo ordine è in attesa di approvazione',
    [FULFILLMENT_STATUSES.reviewed]: 'Questo ordine è in attesa di approvazione',
    [FULFILLMENT_STATUSES.accepted]: 'Questo ordine è in fase di elaborazione',
    [FULFILLMENT_STATUSES.preparing]: 'Questo ordine è in fase di elaborazione',
    [FULFILLMENT_STATUSES.ready]: 'Questo ordine è pronto per il ritiro da parte del cliente',
    [FULFILLMENT_STATUSES.on_delivery]: 'Questo ordine è in consegna al cliente',
    [FULFILLMENT_STATUSES.picked]: 'Questo ordine è stato evaso con successo',
    [FULFILLMENT_STATUSES.rejected]: 'Questo ordine è stato rifiutato e rimborsato',
    default: 'Questo ordine è stato evaso con successo',
  },
  adjustment_reasons: {
    [REFUND_REASONS.RequestedByCustomer]: 'Richiesto dal cliente',
    [REFUND_REASONS.Reclamation]: 'Reclamo',
    [REFUND_REASONS.CommunicationError]: 'Errore di comunicazione',
    [REFUND_REASONS.Other]: 'Altro',
    [REFUND_REASONS.Dispute]: 'Contestazione cliente',
    dispute_win: 'Contestazione cliente vinta',
    null: '',
    undefined: '',
  },
  labels: {
    discount: 'Sconto',
    driver_name: 'Nome corriere',
    driver_phone_number: 'Telefono corriere',
    pin_code: 'PIN',
    invoice_payment: 'Pagamento tramite fattura',
    paid_in_cash: 'Pagamento in contanti',
    customer_paid_online: 'Cliente ha pagato online',
    phone: 'Tel',
    email: 'Email',
    points_used: 'Questo ordine include un premio fedeltà riscattato da un cliente fedele',
    delivery: 'Consegna',
    pickup: 'Ritiro',
    original: 'Originale',
    delivery_fee: 'Costi di consegna',
    tip: 'Mancia',
    service_fee: 'Elaborazione online',
    payment_method_upcharge_fee: {
      [PaymentMethods.PAYPAL]: 'Commissione PayPal',
    },
    discount_breakdown: {
      [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: 'Percentuale di sconto sul totale applicata',
      [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: 'Percentuale di sconto sui prodotti applicata',
      [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: 'Importo di sconto sui prodotti applicato',
      [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: 'Importo di sconto sul totale applicato',
      [OFFER_KIND.BOGO]: 'Bogo applicato',
      [OFFER_KIND.BOGO_HALF_PRICE]: 'Bogo metà prezzo applicato',
      [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: 'Articolo gratuito per prodotti applicato',
      [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: 'Articolo gratuito per totale applicato',
      GiftCard: 'Gift card applicata',
      Reward: 'Punti fedeltà applicati',
      CashbackAccount: 'Punti fedeltà applicati',
      PromoCodeComponent: 'Promo applicata',
      Offer: 'Offerta applicata',
    },
    total_discount: 'Promo applicata',
    tax: 'Imposte',
    total: 'Totale',
    today: 'Oggi',
  },
  schedule: {
    header: 'Programmato per {{date}}, {{time}}',
    text: "Ti ricorderemo quando è il momento di iniziare a preparare l'ordine",
  },
};
